import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  NgbModal,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { OperatorFunction } from "rxjs/interfaces";
import { Observable } from "rxjs/Observable";
import { debounceTime, distinctUntilChanged, mergeMap } from "rxjs/operators";
import { BrotherAttributionService } from "../../../../_services/brother-attribution.service";

import { fromPromise } from "rxjs/observable/fromPromise";
import { TranslationService } from "../../../../_services/translation.service";
import { ITranslations } from "../../../../_models/ITranslations";
import { UserManagementService } from "../../../../_services/user-management.service";

export interface ChildObjectForEdit {
  id: number;
  firstName: string;
  lastName: string;
  layer: string;
  nest: string;
  address: string;
  israeliId: string;
}

@Component({
  selector: "user-management-search-box",
  templateUrl: "./user-management-search-box.component.html",
  styleUrls: [
    "../../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
    "user-management-search-box.component.scss",
  ],
})
export class UserManagementSearchBoxComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild("resultTemplate") public resultTemplate;
  @ViewChild("autoCompleteInput")
  public autoCompleteInput: ElementRef;
  public translations$: Observable<ITranslations>;
  @Output("updateSearchResults")
  public updateSearchResults: EventEmitter<string> = new EventEmitter<string>();
  @Output("executeSearch")
  public executeSearch: EventEmitter<void> = new EventEmitter<void>();
  @Output("userSelected")
  public userSelectedFromSearchBox: EventEmitter<ChildObjectForEdit> = new EventEmitter<ChildObjectForEdit>();

  constructor(
    private modalService: NgbModal,
    private brotherAttributionService: BrotherAttributionService,
    private userManagementService: UserManagementService,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {
    this.userManagementService.searchUserFromAutoComplete("אבי").then();
  }

  public searchHandler: OperatorFunction<string, any> = (
    text$: Observable<any>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      mergeMap((term): any => {
        return fromPromise(
          this.userManagementService.searchUserFromAutoComplete(term)
        );
      })
    );

  public formatter = (x: { name: string }) => x.name;

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  public getResultTemplate() {
    return this.resultTemplate;
  }
  public handleFreeSearch($event) {
    const searchText = this.autoCompleteInput.nativeElement.value as string;
    this.executeSearch.emit();
  }

  public childSelected($event: NgbTypeaheadSelectItemEvent) {
    $event.preventDefault();
    this.autoCompleteInput.nativeElement.value = "";
    const childSelected = $event.item as ChildObjectForEdit;

    this.userSelectedFromSearchBox.emit(childSelected);
  }

  public disableClick($event, stop: boolean) {
    if (!stop) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }

  public textChanged($event: Event) {
    this.updateSearchResults.emit(
      ($event.target as HTMLInputElement).value as string
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-page/user-management-search-box/user-management-search-box.component.ts